import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { transportApiSlice } from "../../../api/rtk/base/slices/transportApiSlice";
import { changeNoValueStyle } from "../../../pages";
import { Col, Row } from "react-bootstrap";
import { Loader } from "../../loaders/Loader";
import { useDispatch } from "react-redux";
import { setTransportObjectInfoStateNumber } from "../../../stateManagement/reducers/transport/TransportObjectInfoSlice";
import { classNames } from "primereact/utils";
import ToastMessageContainer from "../../toastMessageContainer/ToastMessageContainer";
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from "../../../stateManagement/reducers";

function checkTextForUndefined(text: any) {
    if (text != null) return text
    else return "не указано"
}

export default function TransportObjectInfoSection({ type }: any) {
    const dispatch = useDispatch()
    const { transportId } = useParams();
    // запрос на получение информации о пользователе
    const {
        data: transportInfo,
        isFetching: transportInfoIsFetching,
        isError: transportInfoError
    } = transportApiSlice.useFetchTransportByIdQuery({ id: transportId })

    const { carBrand, company, garageNumber, objectId, stateNumber, memo }: any = transportInfo ? transportInfo[0] : {}

    useEffect(() => {
        if (stateNumber) {
            dispatch(setTransportObjectInfoStateNumber(stateNumber))
        }
    }, [stateNumber])

    // изменение стиля строк с отсутствующим значением при поднятии компонента
    useEffect(() => {
        changeNoValueStyle();
    }, [transportInfo]);

    useEffect(() => {
        if (transportInfoIsFetching) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [transportInfoIsFetching])

    useEffect(() => {
        if (transportInfoError) {
            dispatch(showToastMessage({ messageText: "Не удалось загрузить информацию о транспорте", messageType: "error" }))
        }
    }, [transportInfoError])

    let mainClassName = classNames({
        "basic-info-div": true,
        "half-height": type === "history"
    })

    return (
        <div className={mainClassName}>
            <ToastMessageContainer />
            {!transportInfoIsFetching
                ?
                <>
                    {!transportInfoError
                        ?
                        <>
                            <Row>
                                <div className="section-name">Основное</div>
                            </Row>
                            <Row xs={1} md={2} lg={4} xxl={6}>
                                <Col className="field" >Идентификатор ТС</Col>
                                <Col className="value" >{checkTextForUndefined(objectId)}</Col>
                                <Col className="field" >Гаражный номер</Col>
                                <Col className="value" >{checkTextForUndefined(garageNumber)}</Col>
                                <Col className="field" >Гос.номер</Col>
                                <Col className="value">{checkTextForUndefined(stateNumber)}</Col>
                                <Col className="field" >Марка ТС</Col>
                                <Col className="value">{checkTextForUndefined(carBrand)}</Col>
                                <Col className="field" >Компания</Col>
                                <Col className="value">{checkTextForUndefined(company)}</Col>
                                <Col className="field" >Описание</Col>
                                <Col className="value">{checkTextForUndefined(memo)}</Col>
                            </Row>
                        </>
                        :
                        <></>
                    }
                </>
                :
                <Loader />
            }
        </div>
    )
}
